import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { useGetCompanyName, useGetCompanyToken } from "../../api/company";
import { usePostUserCognitoLogin, usePostUserDetails } from "../../api/userDetails";
import { notificationSetupService } from "../../config/firebase";
import { errorView } from "../../helpers/ErrorHandler";
import { useAuthContext } from "../../hooks/useAuthContext";
import {
  removeTokens,
  saveCompanyTenantId,
  saveCompanyTokenInLocal,
  saveOidcToken,
  saveRefreshTokenInLocal,
  saveTenantId,
  saveTokenExpiration,
  saveTokenInLocal,
  saveUserTenantId
} from "../../utils/cacheStorage";
import { checkAvailableUserCompanyId } from "../../utils/utils";
import "./Login.scss";

const CognitoLogin = () => {
  const auth = useAuth();

  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const { dispatch, setCompany, logout } = useAuthContext();

  const { data: userData, mutate } = usePostUserCognitoLogin();

  const { data: userProfileData, mutate: loadUserData } = usePostUserDetails();

  const { data: company, status } = useGetCompanyName(userProfileData?.tenantId);

  const { mutate: getCompanyToken } = useGetCompanyToken();

  const loadUserDetails = (userData: any) => {
    if (userData?.isPasswordResetRequired) {
      navigate("/password-reset", {
        state: {
          isPasswordResetRequired: userData?.isPasswordResetRequired || false,
          email: userEmail
        }
      });
    } else {
      loadUserData("");
    }
  };

  useEffect(() => {
    if (auth.isAuthenticated) {
      saveOidcToken(auth.user?.id_token || "");
      setUserEmail(auth.user?.profile?.email || "");
      mutate(
        {
          token: auth.user?.id_token
        },
        {
          onSuccess: data => {
            saveTokenInLocal(data.token);
            saveRefreshTokenInLocal(data.refreshToken);
            saveTokenExpiration(data.expiredIn);
            loadUserDetails(data);
          }
        }
      );
    } else if (!auth.isAuthenticated && !auth.isLoading) {
      onLogin();
    } else {
      removeTokens();
      setCompany("", "");
      logout();
    }
  }, [auth.isAuthenticated, auth.isLoading]);

  const loadCompanyDetials = () => {
    let { id, status, name, tenantId } = checkAvailableUserCompanyId(company, userProfileData);
    if (status) {
      getCompanyToken(id, {
        onSuccess: data => {
          saveCompanyToken(data);
        }
      });
      setCompany(name, id);
    } else {
      errorView("User hasn't any company");
      removeTokens();
    }
  };

  const saveCompanyToken = (data: any) => {
    saveCompanyTokenInLocal(data?.token || null);
    saveRefreshTokenInLocal(data?.refreshToken || null);
    saveTokenExpiration(data?.expiredIn || null);
    saveCompanyTenantId(userProfileData?.tenantId || null);
    saveUserTenantId(userProfileData?.tenantId || null);
    requestPermission(userProfileData);
    saveTenantId(userProfileData?.tenantId || null);
    if (userData) {
      if (userData?.isPasswordResetRequired || false) {
        navigate("/password-reset", {
          state: {
            isPasswordResetRequired: userData?.isPasswordResetRequired || false,
            email: userEmail
          }
        });
      } else {
        if (userProfileData && data) {
          dispatch({ type: "LOGIN", payload: userProfileData });
          navigate("/", {
            state: { isPasswordResetRequired: false, email: userEmail }
          });
        }
      }
    }
  };

  const requestPermission = (userProfileData: any) => {
    notificationSetupService.setup(userProfileData, () => {});
  };

  useEffect(() => {
    if (status == "success") {
      loadCompanyDetials();
    }
  }, [status == "success"]);

  const onLogin = async () => {
    console.log("Redirecting to login...");
    await auth.signinRedirect();
  };

  return (
    <div className="mainContaa">
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    </div>
  );
};
export default CognitoLogin;
